import { Boxes, Layers, Wrench, Package, type LucideIcon } from 'lucide-react'

/**
 * Tipo de paquete de Zeus (`PackageServiceType`). El portal agrupa el catálogo
 * por TIPO — Planes / Módulos / Servicios — no por las 12 `category` viejas.
 */
export type PackageType = 'PLAN' | 'MODULE' | 'SERVICE'

/** Etiqueta en español de cada tipo, tal como se muestra en el portal. */
export const PACKAGE_TYPE_LABELS: Record<PackageType, string> = {
  PLAN: 'Planes',
  MODULE: 'Módulos',
  SERVICE: 'Servicios',
}

/** Orden de presentación de los tipos en el catálogo. */
export const PACKAGE_TYPE_ORDER: readonly PackageType[] = ['PLAN', 'MODULE', 'SERVICE']

/**
 * Normaliza el `type` que llega del backend. Si viniera vacío o desconocido cae
 * a `SERVICE` (mismo default que el modelo de Zeus).
 */
export function normalizePackageType(type: string | null | undefined): PackageType {
  return type === 'PLAN' || type === 'MODULE' || type === 'SERVICE' ? type : 'SERVICE'
}

const TYPE_ICONS: Record<PackageType, LucideIcon> = {
  PLAN: Layers,
  MODULE: Boxes,
  SERVICE: Wrench,
}

/** Ícono representativo del tipo de paquete. */
export function iconForType(type: PackageType): LucideIcon {
  return TYPE_ICONS[type] ?? Package
}
